import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import isSpa from "shared/util/isSpa";
import { isMobile } from "shared/util/EnvironmentHelpers";
import Link from "shared/components/Link";

import NavBarLink from "./NavBarLink";
import LikesLink from "./LikesLink";
import MessagesButton from "./MessagesButton";
import MessagesButtonContent from "./MessagesButtonContent";
import { selectedOptionOnNavBarEvent } from "routers/Desktop/NavBar/components/util/analytics";
import { AUTHED_ROUTES } from "routers/shared/util/consts";

import DoubleTakeIcon from "./icons/DoubleTake.svg";
import SearchIcon from "./icons/Search.svg";
import DiscoverIcon from "./icons/Discover.svg";

const LoggedInLinks = ({ pathname, likesCount, messagesCount }) => {
	return (
		<>
			<NavBarLink
				isSelected={pathname === "/doubletake" || pathname === "/quickmatch" || pathname === "/home"}
				IconComponent={DoubleTakeIcon}
				text="DoubleTake"
				path="/doubletake"
			/>
			{process.env.PLATFORM === "desktop" && (
				<NavBarLink
					isSelected={pathname === "/discovery"}
					IconComponent={DiscoverIcon}
					text="Discover"
					path="/discovery"
				/>
			)}
			<NavBarLink
				isSelected={pathname === AUTHED_ROUTES.MatchSearch[0]}
				IconComponent={SearchIcon}
				text="Search"
				path={AUTHED_ROUTES.MatchSearch[0]}
				isExternal={isMobile}
			/>
			<LikesLink
				isSelected={pathname === "/who-likes-you" || pathname === "/who-you-like" || pathname === "/intros"}
				likesCount={likesCount}
			/>
			{process.env.PLATFORM === "desktop" && (
				<MessagesButton
					isSelected={pathname === "/messages"}
					messagesCount={messagesCount}
				/>
			)}
			{process.env.PLATFORM === "mobile" && (
				<Link
					to="/messages"
					className={classnames("navbar-link navbar-link--mobile-messages", {
						isSelected: pathname === "/messages",
					})}
					onClick={() => {
						selectedOptionOnNavBarEvent("Messages");
					}}
					noSpa={!isSpa()}
				>
					<MessagesButtonContent
						isSelected={pathname === "/messages"}
						messagesCount={messagesCount}
					/>
				</Link>
			)}
		</>
	);
};

LoggedInLinks.propTypes = {
	pathname: PropTypes.string,
	likesCount: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	messagesCount: PropTypes.number,
};

LoggedInLinks.defaultProps = {
	pathname: null,
	likesCount: null,
	messagesCount: null,
};

export default LoggedInLinks;



// WEBPACK FOOTER //
// ./src/routers/Desktop/NavBar/components/LoggedInLinks.jsx